var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1163 9.00089C16.1163 7.54601 12.9298 6.36523 9.00007 6.36523C5.0703 6.36523 1.88379 7.54601 1.88379 9.00089",
    stroke: "#B7B7B7",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00019 16.1173C12.9304 16.1173 16.1165 12.9313 16.1165 9.00104C16.1165 5.07083 12.9304 1.88477 9.00019 1.88477C5.06998 1.88477 1.88391 5.07083 1.88391 9.00104C1.88391 12.9313 5.06998 16.1173 9.00019 16.1173Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88379 9C1.88379 10.4549 5.0703 11.6357 9.00007 11.6357C12.9298 11.6357 16.1163 10.4549 16.1163 9",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSphere);
export default __webpack_public_path__ + "static/media/ic_sphere.851744792bc79078d8d7003d711b15f3.svg";
export { ForwardRef as ReactComponent };